define(["require", "knockout", "@plugins/knockout-multi-select/model", "@plugins/knockout-multi-select/template.html", "@modules/insensitiveProperty"], function (require, ko, model, template, getPropertyCaseInsensitive) {
    var createViewModel = function (params, componentInfo) {
        return new model(params, componentInfo);
    };

    ko.components.register("multi-select", { template: template, viewModel: { createViewModel: createViewModel } });
});
